
var profileDropDown = null;
var verticalNavMenu = null;
var mainLayout = null;
class HealthExpress {
	constructor() {
		//console.log('HealthExpress Constructor');
	}
	$hasOwnProperty (obj, key) {
		return Object.prototype.hasOwnProperty.call(obj, key);
	}
	setProfileDropDown (val) {
		profileDropDown = val;
	}
	setVerticalNavMenu (val) {
		verticalNavMenu = val;
	}
	setMainLayout (val) {
		mainLayout = val;
	}
	logout () {
		console.log('HealthExpress logout');
		if (profileDropDown) {
			console.log('HealthExpress logout profileDropDown');
			profileDropDown.logout();
		} else {
			setTimeout(function () {
				document.location.reload();
			}, 1000);
		}
	}
	setMenuDisabledGroups (val) {
		if (verticalNavMenu) {
			verticalNavMenu.setDisabledGroups(val);
		}
	}
	setMenuDisabledItems (val) {
		if (verticalNavMenu) {
			verticalNavMenu.setDisabledItems(val);
		}
	}
	setBreadcrumbMenuDisabled (val) {
		if (mainLayout) {
			mainLayout.setBreadcrumbMenuDisabled(val);
		}
	}
	setMenuDisabled (val, root) {
		if (root) {
			if (root.$router) {
				root.$router.isBusy = val;
			}
			if (root.$store) {
				root.$store.commit("ROUTER_IS_BUSY", val);
			}
		}
		this.setMenuDisabledGroups(val);
		this.setMenuDisabledItems(val);
		this.setBreadcrumbMenuDisabled(val);
	}
	removeAccents (str, removeSpaces) {
		if (removeSpaces === true) {
			return str.normalize('NFD').replace(/[\u0300-\u036f]/g, '').replace(/\s+/g, '');
		}
		return str.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
	}
	capitalizeFirstLetter (string) {
		return string.charAt(0).toUpperCase() + string.slice(1);
	}
}
const healthExpress = new HealthExpress();

export default healthExpress;
